/**
 * Global JSON-LD Schema Configuration
 * Add your custom schemas here to be applied site-wide
 */

// Custom FAQPage JSON-LD schema
const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How does cash back work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'There are four main ways to earn with Chirpyest. (1) Use the browser extension: install it from our homepage by clicking "Add Chirpyest to your browser" (Chrome) or install the Safari extension. A Chirpyest bird icon will appear; pin it, create your account, visit a partner retailer, then click the icon and choose "Activate Cash Back" before you shop. (2) Share products with your network using Convert a Link to post affiliate links on social, email, or text; purchases through your links can earn you commissions. (3) Shop through the Chirpyest store: log in, browse partner brands at https://chirpyest.com/brands, and complete your purchase within 24 hours; each item shows the cash back rate. (4) Personal shopping boards: save and organize products into boards you can share; purchases from your boards can earn you extra commissions. Note: using other cash back programs or clearing cookies can void cash back, so shop directly through Chirpyest.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I get paid?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Chirpyest sends payouts automatically via PayPal or Venmo twice a month once your available balance is at least $5. To set up: go to Your Account → Accounts + Settings and enter your PayPal or Venmo details. Cash back is tracked through affiliate network partnerships; if a retailer does not recognize a transaction as eligible, cash back will not be credited.',
      },
    },
    {
      '@type': 'Question',
      name: "What if I don't have PayPal?",
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'No problem. Creating a PayPal account is quick and secure, and users must be 18 or older. Chirpyest uses PayPal because it is widely trusted. Chirpyest also supports Venmo for convenient payouts.',
      },
    },
    {
      '@type': 'Question',
      name: 'Why are payouts not immediate?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          "Payments are finalized within 30 to 180 days of purchase, depending on the retailer's return policy. We wait until the return window closes to ensure accuracy and prevent issues from returns or cancellations. This timing is standard in affiliate marketing.",
      },
    },
    {
      '@type': 'Question',
      name: 'When will I start seeing earnings?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'After you accumulate at least $5 in cash back and the return period ends, your earnings appear in your Chirpyest dashboard. For most brands, first cash back can appear in about 30 days; for longer return policies, it may take up to 180 days. Your dashboard shows affiliate link performance, analytics, and total cash back.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I get paid through Venmo?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Yes. Chirpyest supports Venmo payouts. Choose Venmo or PayPal in your payment preferences.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I use coupons or discount codes with Chirpyest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          "Yes, if the codes are valid on Chirpyest or the affiliated retailer's site. Using unauthorized codes may invalidate cash back. Always check the retailer's coupon policy and our platform for eligible codes.",
      },
    },
    {
      '@type': 'Question',
      name:
        'What do I do if I activate cash back but do not see anything in my Chirpyest account?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'If cash back does not appear, the retailer may not have acknowledged the purchase as eligible. Chirpyest tracks purchases through affiliate programs, but cash back is not guaranteed if a retailer does not credit the transaction. Please review our terms for full details.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does Chirpyest compare to competitors?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Chirpyest combines personal cash back with social sharing and personal shopping boards, giving multiple ways to earn. Influencers, creators, small businesses, and everyday shoppers can earn from both their own purchases and from purchases made through their shared links, creating an ongoing affiliate revenue stream. Many competitors only pay on personal purchases.',
      },
    },
    {
      '@type': 'Question',
      name: 'Why should influencers and content creators use Chirpyest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Chirpyest is built for affiliate marketers, influencers, small businesses, and creators. Share products via social or shopping boards, track clicks and sales, and earn on both your purchases and purchases made through your links. It functions like a lightweight affiliate network without technical setup.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does Chirpyest track purchases?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'We use browser cookies, affiliate link tracking, and partnerships with retailer affiliate networks to attribute purchases to your account. Clearing cookies or using other cash back platforms can interfere with tracking and may prevent cash back from being credited.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I earn cash back on every purchase?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Eligibility varies by retailer and promotion. Most purchases from Chirpyest partners qualify, but not all items or brands are eligible. Check the Chirpyest dashboard or browser extension before you shop to confirm current offers and rates.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can Chirpyest help me run an affiliate marketing business?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Yes. By sharing affiliate links and shopping boards, you can monetize content, social channels, or private communities without joining complex networks. Note: when using Chirpyest links in ads, you may not use brand names in search engine paid campaigns or on unauthorized sites. See terms for full restrictions.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is there a mobile option for Chirpyest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Yes. On Safari, download the mobile app/extension and use Chirpyest like desktop. On Chrome and other browsers, add Chirpyest to your bookmarks and Home Screen, log in, visit https://chirpyest.com/brands, and select a brand to activate cash back. You can also paste a product URL into the Create Share Link tool to generate a shareable affiliate link. Mobile shopping boards let you save, organize, and share products for easier earnings.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do I need to be an influencer to earn with Chirpyest?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'No. Anyone can earn cash back by shopping through Chirpyest. Creators and influencers can earn more by sharing links or boards with their audiences.',
      },
    },
    {
      '@type': 'Question',
      name:
        'How does Chirpyest compare to other top affiliate and cash back platforms?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Chirpyest blends personal cash back with creator tools such as shopping boards, social sharing, and transparent analytics. While services like Rakuten or RetailMeNot focus on personal rebates, Chirpyest also enables earnings from your audience, similar to LTK, ShopMy, or Skimlinks, and provides access to premium retailers with real affiliate commission rates.',
      },
    },
  ],
}

/**
 * Array of all global schemas to be applied site-wide
 * Add your custom schemas to this array
 */
export const globalSchemas = [
  faqPageSchema, // Custom FAQPage schema
]

export default globalSchemas
